import { getCustomerPersonList } from '#api/confirmation_forms';
import LoadingSpinner from '#atoms/LoadingSpinner';
import { useQuery } from '@tanstack/react-query';
import Group from './Group';

interface ExerciseChartListProps {}

const ExerciseChartList = ({}: ExerciseChartListProps) => {
  const sessionPersonId = sessionStorage.getItem('personId');

  const { data, isLoading } = useQuery(
    ['COACH_ALL_RECORDS'],
    () =>
      getCustomerPersonList({
        personId: sessionPersonId || ''
      }),
    {
      enabled: !!sessionPersonId
    }
  );

  if (!data) return null;

  if (isLoading)
    return (
      <div className="w-full h-full">
        <LoadingSpinner />
      </div>
    );

  return (
    <div className="px-20 w-full flex flex-col gap-12">
      {data.data.length === 0 && (
        <div className="w-full h-[102px] px-5 py-10 rounded-lg justify-center items-center gap-2.5 inline-flex">
          <div className="text-[#938f9e] text-[17px] font-medium font-['Pretendard Variable'] leading-snug">
            등록된 운동차트가 없습니다
          </div>
        </div>
      )}

      {data.data.length > 0 &&
        data.data.map(item => <Group key={item.id} {...item} />)}
    </div>
  );
};

export default ExerciseChartList;
